var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<input bs-datepicker ng-model=\"vm.parameter[vm.key].wert\" ng-attr-id=\"{{ vm.param_id }}\" ng-attr-name=\"{{ vm.param_id }}\" placeholder=\"{{:: vm.filter.filter[key].dateRangeMinPlaceholder}}\" class=\"form-control\">");;return buf.join("");
}